var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwoDayDeliveryTruckIcon = function SvgTwoDayDeliveryTruckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 11 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.706 6.016h-.04V3.871a.28.28 0 0 0-.082-.198L7.982 2.072a.28.28 0 0 0-.201-.083H6.625v-.854a.663.663 0 0 0-.664-.663H.664A.663.663 0 0 0 0 1.135V6.4c0 .366.297.663.664.663h.283c0-.89.724-1.613 1.614-1.613s1.613.723 1.613 1.613h1.898c0-.89.724-1.613 1.613-1.613.89 0 1.613.723 1.613 1.613h.408a.53.53 0 0 0 .527-.524.525.525 0 0 0-.527-.523m-.96-1.49H6.625V3h.911l1.21 1.209z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.685 5.654a1.41 1.41 0 1 0 1.41 1.41 1.41 1.41 0 0 0-1.41-1.41m0 2.205a.796.796 0 1 1 0-1.592.796.796 0 0 1 0 1.592M2.56 5.654a1.41 1.41 0 0 0-1.409 1.409 1.41 1.41 0 0 0 2.819 0c0-.777-.632-1.41-1.41-1.41m0 2.205a.796.796 0 1 1 0-1.593.796.796 0 0 1 0 1.593"
  })));
};
export default SvgTwoDayDeliveryTruckIcon;